/**
 * [Canvass this, CT-10] Gate on "Back to organizer". On web it always lets the organizer through;
 * the native shell's biometric/PIN confirmation plugs in here (Part B §B2). Resolves false to cancel.
 */
export function confirmReturnToOrganizer(): Promise<boolean> {
  return Promise.resolve(true)
}
